"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UpscopeAPI = exports.canUseDom = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * This is the equivalent of calling `window.Upscope()`
 * for a full list of API methods see https://github.com/upscopeio/js-api
 */

exports.canUseDom = canUseDom;

var UpscopeAPI = function UpscopeAPI() {
  if (canUseDom && window.Upscope) {
    var _window;

    (_window = window).Upscope.apply(_window, arguments);
  } else {
    console.warn('Upscope has not been initialized'); // eslint-disable-line no-console
  }
};

exports.UpscopeAPI = UpscopeAPI;

var ReactUpscope = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ReactUpscope, _React$Component);

  var _super = _createSuper(ReactUpscope);

  function ReactUpscope(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReactUpscope);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    var _this$props = _this.props,
        appID = _this$props.appID,
        identities = _this$props.identities,
        identityUuid = _this$props.identityUuid;
    if (!canUseDom || !appID) return (0, _possibleConstructorReturn2.default)(_this);
    if (window.Upscope) return (0, _possibleConstructorReturn2.default)(_this);

    var i = function i() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      i.c(args);
    };

    i.q = [];

    i.c = function (args) {
      i.q.push(args);
    };

    var l = function l() {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = "https://code.upscope.io/".concat(appID, ".js");
      document.head.appendChild(s);
    };

    if (typeof window.Upscope !== 'function') {
      window.Upscope = i;
      l();
    }

    if (window.Upscope) {
      window.Upscope('init', {
        identities: identities,
        uniqueId: identityUuid
      });
    }

    return _this;
  }

  (0, _createClass2.default)(ReactUpscope, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!canUseDom || !window.Upscope) return;
      delete window.Upscope;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var identities = _ref.identities,
          identityUuid = _ref.identityUuid;
      if (!canUseDom || !window.Upscope) return null;
      window.Upscope('updateConnection', {
        identities: identities,
        uniqueId: identityUuid
      });
      return null;
    }
  }]);
  return ReactUpscope;
}(_react.default.Component);

exports.default = ReactUpscope;
(0, _defineProperty2.default)(ReactUpscope, "propTypes", {
  /**
   * The API key supplied from app.upscope.io/install
   */
  appID: _propTypes.default.string.isRequired,

  /**
   * Optionally set the user's name or email (e.g. ["John Smith", "john.smith@acme.com"])
   */
  identities: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Optionally set the user ID
   */
  identityUuid: _propTypes.default.string
});
(0, _defineProperty2.default)(ReactUpscope, "defaultProps", {
  identities: [],
  identityUuid: null
});